import React from 'react';

import { Alert, Button, Group, Stack, Text, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

import styles from './DeviceScheduleModal.module.scss';

interface SchedulesSummaryProps {
  appointmentType: string;
  nextDates?: string[];
  errorMessage?: string | null;
  onClose: () => void;
}

const SchedulesSummary: React.FC<SchedulesSummaryProps> = ({
  appointmentType,
  nextDates,
  errorMessage,
  onClose
}) => {
  return (
    <Stack gap="xs" px={20} pt={16}>
      <Title order={4} fw={600} mb={4} c="dark.9">
        Summary
      </Title>

      {errorMessage ? (
        <>
          <Alert icon={<IconAlertCircle size="1rem" />} title="Error" color="red" mb={16}>
            {errorMessage}
          </Alert>
          <Text size="sm" fw={500} c="dark.7">
            Failed to create {appointmentType} appointment. Please try again.
          </Text>
        </>
      ) : (
        <>
          <Text size="sm" fw={500} mb={8} c="dark.7">
            Summary of changes
          </Text>

          <Title order={5} fw={600} mb={4} c="dark.9">
            Schedules
          </Title>

          <Stack gap="xs" mb={16}>
            {nextDates && nextDates.length > 0 ? (
              nextDates.map((summary, index) => (
                <Text key={index} size="sm" c="dark.7">
                  {summary}
                </Text>
              ))
            ) : (
              <Text size="sm" c="dark.7">
                No scheduled dates available.
              </Text>
            )}
          </Stack>
        </>
      )}

      <Group className={styles.buttonGroup} justify="flex-end">
        <Button onClick={onClose} className={styles.modalButton}>
          Close
        </Button>
      </Group>
    </Stack>
  );
};

export default SchedulesSummary;
